import moment from 'moment'
export function parseDate(val, format = 'YYYY-MM-DD HH:mm:ss') {
	if (!val) {
		return ''
	}
	return moment(val).format(format)
}
export function toThousands(num) {
	num = (num || 0).toString()
	var result = ''
	while (num.length > 3) {
		result = ',' + num.slice(-3) + result
		num = num.slice(0, num.length - 3)
	}
	if (num) {
		result = num + result
	}
	return result
}

/**
 * 金钱格式化
 * @param {Number} num 传入的数字参数
 * @param {Boolean} isInt 是否改成是整数
 * @param {Number} decimalDigits 保留的小数位数
 */
export function separator(num, isInt = false, decimalDigits = 2) {
	if (num === '--') {
		return num;
	}
	if (!num) {
		return '0'
	}
	let str = ''
	str = parseFloat(num).toFixed(decimalDigits)

	// str = str.toString()
	let result =
		str &&
		str.toString().replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
			return $1 + ','
		})
	if (isInt) {
		// 去除小数点后面的内容
		result = result.split('.')[0]
	}
	return result
}

/**
 * 金钱格式化版本2 如果是null 显示--
 * @param {Number} num 传入的数字参数
 * @param {Boolean} isInt 是否改成是整数
 * @param {Number} decimalDigits 保留的小数位数
 */
export function separatorNull(num, isInt = false, decimalDigits = 2) {
	if (num != 0 && !num) {
	  return '--'
	}
	if (num == 0) {
		return '0'
	}
	let str = ''
	str = parseFloat(num).toFixed(decimalDigits)

	// str = str.toString()
	let result =
		str &&
		str.toString().replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
			return $1 + ','
		})
	if (isInt) {
		// 去除小数点后面的内容
		result = result.split('.')[0]
	}
	return result
}

export function dateFormat(val) {
	if (!val) {
		return ''
	}
	return moment(val).format('YYYY-MM-DD')
}



// WEBPACK FOOTER //
// ./src/filters/index.js